export default __webpack_public_path__ + "2dce46b737557126edff6590e835f6fe.png";